import Parse from 'parse'
import {ParseDbService, mediaSchema as Schema} from "./parse.db.service";

function getAll(pagination, search) {
    let query = new Parse.Query(ParseDbService.MediaClassName);
    if (pagination) {
        query.skip((pagination.page - 1) * pagination.perPage)
            .limit(pagination.perPage)
    }

    query.withCount(true);

    if (search !== undefined && search != null && search.length !== 0) {
        query.contains(Schema.title, search);
    }

    return query.find().then(items => {
        return {
            results: items.results.map(item => {
                return {
                    parseItem: item,
                    title: item.get(Schema.title),
                    mediaId: item.get(Schema.mediaId)
                }
            }),
            count: items.count
        }
    });
}


function add(item) {
    let Media = Parse.Object.extend(ParseDbService.MediaClassName, null, null);
    let mediaObj = new Media();

    const query = new Parse.Query(ParseDbService.MediaClassName)
    query.equalTo(Schema.mediaId, parseInt(item.mediaId));
    query.limit(1);

    return query.withCount(true).find(null).then((items) => {
        if (items.count) {
            return Promise.reject("item with same media id exists");
        } else {
            mediaObj.set(Schema.title, item.title.toLowerCase());
            mediaObj.set(Schema.mediaId, parseInt(item.mediaId));
            return mediaObj.save();
        }
    })
}

function edit(item) {
    let mediaObj = item.parseItem;
    mediaObj.set(Schema.title, item.title.toLowerCase());
    mediaObj.set(Schema.mediaId, parseInt(item.mediaId));
    return mediaObj.save();
}

export const MediaService = {
    getAll,
    add,
    edit
};
